import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CARDS = [
  {
    to: "/para-produtores",
    testid: "journey-card-produtores",
    eyebrow: "Produtores rurais",
    title: "Sou produtor rural",
    text: "Crédito do Plano Safra, regularização da terra, renegociação de dívidas e seguro — explicado do jeito simples.",
  },
  {
    to: "/para-advogados",
    testid: "journey-card-advogados",
    eyebrow: "Advogados e escritórios",
    title: "Sou advogado(a)",
    text: "Perícia, assistência técnica e avaliações fundamentadas na NBR 14653, preparadas para o contraditório, para os casos do seu escritório.",
  },
  {
    to: "/para-instituicoes-financeiras",
    testid: "journey-card-bancos",
    eyebrow: "Bancos e cooperativas",
    title: "Sou banco ou cooperativa",
    text: "Laudos de avaliação de garantias, laudos técnicos agronômicos e laudos de sinistro com padrão técnico.",
  },
];

export const Journeys = () => (
  <section data-testid="journeys-section" className="mx-auto max-w-[1400px] px-5 pb-8 pt-4 sm:px-8">
    <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 md:grid md:grid-cols-3 md:gap-5 md:overflow-visible md:pb-0">
      {CARDS.map((c, i) => (
        <Reveal key={c.to} delay={0.08 * i} className="h-full">
          <Link
            to={c.to}
            data-testid={c.testid}
            className="group flex h-full w-[85%] min-h-0 shrink-0 snap-center flex-col justify-between rounded-[24px] border border-[#E5E0D5] bg-white p-4 transition-[box-shadow,border-color,transform] duration-500 hover:-translate-y-1 hover:border-[#233D25] hover:shadow-[0_30px_70px_-35px_rgba(31,58,36,0.45)] sm:w-[70%] sm:p-8 md:w-auto md:min-h-[220px] md:shrink"
          >
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#5D995E]">{c.eyebrow}</p>
              <h2 className="mt-3 font-serif text-2xl leading-tight sm:mt-3 sm:text-3xl">{c.title}</h2>
              <p className="mt-3 text-base leading-relaxed text-[#4A5549] sm:text-base">{c.text}</p>
            </div>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#233D25]">
              Ver como ajudamos
              <span className="grid h-9 w-9 place-items-center rounded-full border border-[#233D25]/25 transition-[transform,background-color,color] duration-500 group-hover:rotate-45 group-hover:bg-[#233D25] group-hover:text-[#F9F8F3]">
                <ArrowUpRight className="h-4 w-4" />
              </span>
            </span>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
